// extracted by mini-css-extract-plugin
export var table = "_yt-0";